import {FlagIconByLocale} from '../../icons/flag-icons-by-locale'
import type {BioIconProps} from '../../icons/common-types'

export default function CanadaBest10Logo({locale, ...attributes}: BioIconProps) {
  return (
    <div className="domain_logo relative flex w-fit items-center gap-2 text-2xl font-semibold text-white tablet:gap-1 tablet:text-base">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M7.6538 21.3337C7.80046 20.6803 7.5338 19.747 7.06713 19.2803L3.82713 16.0403C2.8138 15.027 2.4138 13.947 2.70713 13.0137C3.0138 12.0803 3.96046 11.4403 5.3738 11.2003L9.5338 10.507C10.1338 10.4003 10.8671 9.86699 11.1471 9.32033L13.4405 4.72033C14.1071 3.40033 15.0138 2.66699 16.0005 2.66699C16.9871 2.66699 17.8938 3.40033 18.5605 4.72033L20.8538 9.32033C21.0271 9.66699 21.3871 10.0003 21.7738 10.227L7.4138 24.587C7.22713 24.7737 6.90713 24.6003 6.96046 24.3337L7.6538 21.3337Z"
          fill="white"
        />
        <path
          d="M24.9334 19.2795C24.4534 19.7595 24.1867 20.6795 24.3467 21.3329L25.2667 25.3462C25.6534 27.0129 25.4134 28.2662 24.5867 28.8662C24.2534 29.1062 23.8534 29.2262 23.3867 29.2262C22.7067 29.2262 21.9067 28.9729 21.0267 28.4529L17.1201 26.1329C16.5067 25.7729 15.4934 25.7729 14.8801 26.1329L10.9734 28.4529C9.4934 29.3195 8.22673 29.4662 7.4134 28.8662C7.10673 28.6395 6.88007 28.3329 6.7334 27.9329L22.9467 11.7195C23.5601 11.1062 24.4267 10.8262 25.2667 10.9729L26.6134 11.1995C28.0267 11.4395 28.9734 12.0795 29.2801 13.0129C29.5734 13.9462 29.1734 15.0262 28.1601 16.0395L24.9334 19.2795Z"
          fill="white"
        />
      </svg>

      <span>Canada Best 10</span>
      <FlagIconByLocale
        locale={locale}
        className="absolute -right-6 -top-3 size-8 shrink-0 -rotate-12 tablet:-right-4 tablet:-top-1 tablet:size-5"
      />
    </div>
  )
}
